var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_Symbol.js
// module id = ./node_modules/lodash/_Symbol.js
// module chunks = 168707334958949